import styled from 'styled-components';
import {dFlexCenter} from '../../../globalVariables/GlobalFlex';
import {getFontSize, getFontWeight, getToken, getSpacing} from '@tickchak/react-share/app';

export const container = styled.div`
    ${dFlexCenter}
    gap: ${getSpacing('spaceMd')};
    padding: ${getSpacing('spaceSm')};
    background: ${getToken('color.brand.subtle')};
    border-radius: 8px;
    width: 100%;
    font-size: ${getFontSize('caption')};
    font-weight: ${getFontWeight('semibold')};
    color: ${getToken('color.turquoise.700')};
    line-height: ${getToken('typography.lineHeight.caption')};
    text-align: start;
    
    svg {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
    }
`;
